import { Injectable } from '@angular/core';
import { BaseService, TournamentRoundApi, TournamentRoundTeam } from '@mtgame/core';
import { Observable } from 'rxjs';

const STORE_TEAMS_KEY = 'teams';

@Injectable()
export class GroupItemService extends BaseService {
  private roundId: number;
  private groupId: number;

  get teams$(): Observable<TournamentRoundTeam[]> {
    return this.store.get(STORE_TEAMS_KEY);
  }

  constructor(
    private tournamentRoundApi: TournamentRoundApi,
  ) {
    super();
  }

  async initialize(roundId: number, groupId: number): Promise<void> {
    this.roundId = roundId;
    this.groupId = groupId;
    await this.getTeams();
  }

  async getTeams(): Promise<TournamentRoundTeam[]> {
    const teams = await this.tournamentRoundApi.getTeams(this.roundId, {groupId: this.groupId});
    this.store.save(STORE_TEAMS_KEY, teams);
    return teams;
  }
}
